import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';

export const ApDefaultRootRoutes = {
  'my.planner': <ng.ui.IState>{
    url: 'planner/',
    abstract: true,
    sticky: true,
    template: `<ui-view></ui-view>
      <busy-indicator></busy-indicator>
      <phx-notification handle="ap-alerts"
        horizontal-position="right"
        respect-eab-header="true">
      </phx-notification>`,
    resolve: {
      studentNk: () => undefined,
      studentValue: (loadStudentValueCommand: ICommand) => loadStudentValueCommand(),
      allowToProceed: (preventAccessAndRedirectToAp3Command: ICommand) => preventAccessAndRedirectToAp3Command()
    }
  },
  'my.planner.default': <ng.ui.IState>{
    url: 'default/',
    onEnter: ($state: ng.ui.IStateService, $timeout: ng.ITimeoutService, appConfigModel: any) => {
      const shouldLoadMultiPlan = appConfigModel.isFeatureEnabled('cat-multitemplate_planner');
      const plannerDefaultState = shouldLoadMultiPlan ? 'my.planner.multiplan.default' : 'my.planner.plan.default';
      $timeout(() => $state.go(plannerDefaultState, {}, { reload: true }), 10);
    }
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/ap_default_root_routes.ts